import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const CloudbucketIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M.04,0v6.11h1.25v13.89h17.43V6.11h1.25V0H.04ZM12.85,11.32h-5.7v-1.72h5.7v1.72ZM17.48,4.54H2.52V1.57h14.97v2.97Z" />
 </svg>,
 "Cloudbucket"
);
